import { render, staticRenderFns } from "./ProductCustomFilter.vue?vue&type=template&id=2c1e3b95&scoped=true"
import script from "./ProductCustomFilter.vue?vue&type=script&lang=js"
export * from "./ProductCustomFilter.vue?vue&type=script&lang=js"
import style0 from "./ProductCustomFilter.vue?vue&type=style&index=0&id=2c1e3b95&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1e3b95",
  null
  
)

export default component.exports